import * as yup from 'yup';

export const REMOTE_DISPENSE_KEY_VALIDATION_SCHEMA = yup.object().shape({
  kiosk: yup.object().shape({
    label: yup.string().required('Kiosk is required'),
    value: yup.string().required('Kiosk is required'),
  }),
});
